// assets/as-scroll-slider.js

window.ASScrollSlider = function ({
  section,
  viewportSelector,
  gridSelector,
  scrollbarSelector,
  fillSelector,
  prevSelector,
  nextSelector,
  itemSelector,
}) {
  if (!section) return;

  const viewport = section.querySelector(viewportSelector);
  const grid = section.querySelector(gridSelector);
  const scrollbar = section.querySelector(scrollbarSelector);
  const fill = section.querySelector(fillSelector);
  const prevBtn = section.querySelector(prevSelector);
  const nextBtn = section.querySelector(nextSelector);

  if (!grid || !viewport) return;

  let isDown = false;
  let isDragging = false;
  let isDraggingScrollbar = false;

  let startX = 0;
  let startTranslate = 0;
  let currentX = 0;
  let targetX = 0;
  let maxMove = 0;

  let currentBarX = 0;
  let targetBarX = 0;
  let currentBarWidth = 22;
  let targetBarWidth = 22;

  const dragLimit = 6;
  const smoothness = 0.35;
  const scrollbarSmoothness = 0.55;

  function clamp(value) {
    return Math.min(0, Math.max(value, -maxMove));
  }

  function setTarget(value) {
    targetX = clamp(value);
  }

  function getStep() {
    const item = grid.querySelector(itemSelector);
    if (!item) return 304;

    const styles = window.getComputedStyle(grid);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);

    return item.offsetWidth + gap;
  }

  function updateArrows() {
    if (!prevBtn || !nextBtn) return;

    if (maxMove <= 2) {
      prevBtn.classList.add("is-hidden");
      nextBtn.classList.add("is-hidden");
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }

    const position = Math.abs(currentX);
    const atStart = position <= 2;
    const atEnd = position >= maxMove - 2;

    prevBtn.classList.toggle("is-hidden", atStart);
    nextBtn.classList.toggle("is-hidden", atEnd);

    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd;
  }

  function updateScrollbar() {
    if (!fill || !scrollbar) return;

    if (maxMove <= 0) {
      targetBarWidth = 100;
      targetBarX = 0;
      return;
    }

    const visibleRatio = viewport.clientWidth / grid.scrollWidth;
    const fillWidthPercent = Math.max(visibleRatio * 100, 18);
    const progress = Math.abs(currentX) / maxMove;

    const scrollbarWidth = scrollbar.offsetWidth;
    const fillWidthPx = (scrollbarWidth * fillWidthPercent) / 100;
    const maxProgressMove = scrollbarWidth - fillWidthPx;

    targetBarWidth = fillWidthPercent;
    targetBarX = progress * maxProgressMove;
  }

  function animateScrollbar() {
    if (!fill) return;

    currentBarX += (targetBarX - currentBarX) * scrollbarSmoothness;
    currentBarWidth += (targetBarWidth - currentBarWidth) * scrollbarSmoothness;

    if (Math.abs(targetBarX - currentBarX) < 0.1) currentBarX = targetBarX;
    if (Math.abs(targetBarWidth - currentBarWidth) < 0.1)
      currentBarWidth = targetBarWidth;

    fill.style.width = `${currentBarWidth}%`;
    fill.style.transform = `translateX(${currentBarX}px)`;

    requestAnimationFrame(animateScrollbar);
  }

  function animate() {
    currentX += (targetX - currentX) * smoothness;

    if (Math.abs(targetX - currentX) < 0.1) {
      currentX = targetX;
    }

    grid.style.transform = `translate3d(${currentX}px, 0, 0)`;

    updateScrollbar();
    updateArrows();

    requestAnimationFrame(animate);
  }

  function calculateSizes() {
    maxMove = Math.max(0, grid.scrollWidth - viewport.clientWidth);

    currentX = clamp(currentX);
    targetX = clamp(targetX);

    updateScrollbar();
    updateArrows();
  }

  grid.querySelectorAll("a, img").forEach((el) => {
    el.setAttribute("draggable", "false");
  });

  grid.addEventListener("pointerdown", (e) => {
    if (e.button !== undefined && e.button !== 0) return;

    if (e.target.closest("a, button")) return;

    isDown = true;
    isDragging = false;

    startX = e.clientX;
    startTranslate = targetX;

    grid.classList.add("is-dragging");

    if (grid.setPointerCapture) {
      grid.setPointerCapture(e.pointerId);
    }
  });

  grid.addEventListener("pointermove", (e) => {
    if (!isDown) return;

    const diff = e.clientX - startX;

    if (Math.abs(diff) > dragLimit) {
      isDragging = true;
    }

    if (isDragging) {
      e.preventDefault();
      setTarget(startTranslate + diff);
    }
  });

  grid.addEventListener("pointerup", () => {
    isDown = false;
    grid.classList.remove("is-dragging");

    setTimeout(() => {
      isDragging = false;
    }, 80);
  });

  grid.addEventListener("pointercancel", () => {
    isDown = false;
    isDragging = false;
    grid.classList.remove("is-dragging");
  });

  grid.addEventListener(
    "click",
    (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true,
  );

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      setTarget(targetX - getStep());
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      setTarget(targetX + getStep());
    });
  }

  if (scrollbar && fill) {
    fill.addEventListener("pointerdown", (e) => {
      isDraggingScrollbar = true;
      fill.classList.add("is-dragging");

      if (fill.setPointerCapture) {
        fill.setPointerCapture(e.pointerId);
      }

      e.stopPropagation();
    });

    fill.addEventListener("pointermove", (e) => {
      if (!isDraggingScrollbar) return;

      const rect = scrollbar.getBoundingClientRect();
      const percent = Math.min(
        1,
        Math.max(0, (e.clientX - rect.left) / rect.width),
      );

      targetX = -(maxMove * percent);
      currentX = targetX;

      grid.style.transform = `translate3d(${currentX}px, 0, 0)`;

      updateScrollbar();
      updateArrows();

      currentBarX = targetBarX;
      fill.style.transform = `translateX(${currentBarX}px)`;
    });

    fill.addEventListener("pointerup", () => {
      isDraggingScrollbar = false;
      fill.classList.remove("is-dragging");

      currentX = targetX;
      currentBarX = targetBarX;

      updateArrows();
    });

    fill.addEventListener("pointercancel", () => {
      isDraggingScrollbar = false;
      fill.classList.remove("is-dragging");
    });

    scrollbar.addEventListener("click", (e) => {
      if (e.target === fill) return;

      const rect = scrollbar.getBoundingClientRect();
      const percent = Math.min(
        1,
        Math.max(0, (e.clientX - rect.left) / rect.width),
      );

      setTarget(-(maxMove * percent));
    });
  }

  window.addEventListener("resize", calculateSizes);

  calculateSizes();
  requestAnimationFrame(animate);

  if (fill) {
    requestAnimationFrame(animateScrollbar);
  }
};
